module.exports = __webpack_public_path__ + "static/media/Cognition.ed27379b.svg";